import { Fragment, useState } from "react";
import { useHistory } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { allIngredientsSelector } from "../../app/commonSelector";
import { UseGetFlag } from "../../app/launchDarkly";
import { setIsViewRecipeOpen } from "../../app/recipePage/recipePage.slice";
import { useAppDispatch, useAppSelector } from "../../app/store/hooks";
import useLogRecipeEdit from "../../hooks/useLogRecipeEdit";
import { Arrow, Ingredients } from "../../iconRef/recipePageIcons";
import { EventLogsEnum } from "../../utils/events";
import { resizeImageIfCloudinary } from "../../utils/images/cloudinaryUtils";
import { logEvents } from "../../utils/logging";
import OpenOnUpliance from "../OpenOnUpliance/OpenOnUpliance";
import IngredientPrep from "../prep/ingredientPrep";
import { TextPrimaryBold, TextSmallBold } from "../typography";
import styles from "./recipeIngredient.module.css";
import ServingSize from "./servingSize";
import UnitDisplay from "./unitDisplay";

const RecipeIngredientsSection = ({ recipe }: { recipe: any }) => {
    const user = useAppSelector((state) => state.main.user);
    const device = useAppSelector((state) => state.main.device);
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { logRecipeEdit } = useLogRecipeEdit();
    const [ingredientPrepOpenIndex, setIngredientPrepOpenIndex] = useState<number | null>(null);
    const { enableViewRecipeMob } = UseGetFlag()
    const ingredientsPerServing = useAppSelector(allIngredientsSelector)
    if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
    }
    const handleIngredientClick = (ingredientId: number | null) => {
        setIngredientPrepOpenIndex(ingredientId);

        logEvents("null", "APP_PREP_OPENED", {
            userId: user?.id,
            deviceId: device?.displayName ?? device?._id,
            RecipeId: recipe?.id
        });

    }
    const onView = () => {
        window.scrollTo(0, 0);
        dispatch(setIsViewRecipeOpen(true));
        logRecipeEdit(EventLogsEnum.APP_RECIPE_VIEW, {
            recipeId: recipe?.id
        });
        history.push(`/recipe/${recipe?.id}`);
    }

    return (
        <Box className={styles.ingredients_view_container}>
            <Box className={styles.ingredients_list_container}>
                <ServingSize maxServing={recipe?.metadata?.maxServing} minServing={recipe?.metadata?.minServing} />

                <Box className={styles.ingredients_card}>
                    <Box className={styles.title_container}><Ingredients /><Typography variant="body5">Ingredients</Typography></Box>
                    {ingredientsPerServing?.map((ingredient: any, index: number) =>
                        <Fragment key={ingredient?.id}>
                            {ingredientsPerServing[index - 1]?.stepName !== ingredient?.stepName &&
                                <Box className={styles.serving_text_container}>
                                    <TextPrimaryBold text={`For ${ingredient?.stepName}` ?? ingredient?.ingredientsTitle} />
                                </Box>
                            }
                            <button className={styles.ingredients_btn} onClick={() => handleIngredientClick(index)}>
                                <Box className={styles.ingredient_detail_container}>
                                    <img alt="default_image" height='60px' src={resizeImageIfCloudinary(ingredient?.image, 140, 120, 140, 120, true)}
                                        width='70px' />
                                    <Box className={styles.ingredient_title_container}>
                                        <TextPrimaryBold text={ingredient?.displayName} />
                                        <TextSmallBold color='#999999' text={ingredient?.prep?.displayName} />
                                    </Box>
                                </Box>
                                <Box className={styles.ingredient_unit_display_container}>
                                    <UnitDisplay ingredient={ingredient} weighScaleAmount={ingredient?.weighScaleAmount} />
                                </Box>
                            </button>
                            {ingredientPrepOpenIndex === index && <IngredientPrep ingredient={ingredient} onClose={() => setIngredientPrepOpenIndex(null)} open={(ingredientPrepOpenIndex === index)} />}
                        </Fragment>
                    )}
                </Box>
                <Box className={styles.btn_container} >
                    <Box className={styles.btn_row}>
                        <OpenOnUpliance />
                        {enableViewRecipeMob && <button className={styles.view_recipe_btn} onClick={onView}>
                            <Typography variant="captionparalell">View Recipe</Typography>
                            <Arrow />
                        </button>}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
export default RecipeIngredientsSection
